import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.network.dns.zone.delete;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_DNS_ZONE_DELETE',
	method: 'POST',
	url: '/network/dns/zone/delete.json',
});

const selectors = {
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
